import { Pipe, PipeTransform } from '@angular/core';
import { SlicePipe } from '@angular/common';

@Pipe({
    name: 'ihdStrSlice'
})
export class StrSlicePipe implements PipeTransform {

    constructor(private slicePipe: SlicePipe) {
    }

    transform(value: string, limit: number, start: number = 0): string {
        if (!value) {
            return;
        }

        return value.length <= limit ? value : this.slicePipe.transform(value, start, limit) + '...';
    }
}
